module.exports = __webpack_public_path__ + "static/media/smiling-face.c01591f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/smiling-face.png
// module id = 676
// module chunks = 1